import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getSurveys } from '../api';
import { SurveyResponseType } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}
export const ITEMS_PER_PAGE_DEFAULT = 10;

export interface SurveyResultsListQuery {
  page: number;
  items_per_page?: number;
  title?: string;
  period?: string;
  surveyContext?: string;
  surveyStatus?: string;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  SurveyResultsListQuery,
  SurveyResponseType,
  AxiosResultDefaultError
>();

export function useSurveyResultsListLoader() {
  return useFetch();
}

export const SurveyResultsListLoaderConsumer = FetchConsumer;

export default function SurveyResultsListLoader({ children }: BaseLoaderProps) {
  const request = useCallback(async (query: SurveyResultsListQuery) => {
    return getSurveys({
      ...query,
      page: query.page - 1,
      items_per_page: ITEMS_PER_PAGE_DEFAULT,
    });
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1 }}
      fetchImmediately={true}
    >
      {children}
    </FetchProvider>
  );
}
